export const LikeIcon = () => (
  <svg width="44" height="32" viewBox="0 0 44 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.0782 14.8091C19.2854 7.484 9.9 9.19038 9.9 15.4751C9.9 21.2396 16.5003 25.5611 21.401 28.7699C21.6308 28.9203 21.8568 29.0683 22.0782 29.2139V29.2303C22.2889 29.0918 22.5036 28.9512 22.7218 28.8083C27.6259 25.596 34.2565 21.2528 34.2565 15.4751C34.2565 9.19038 24.8711 7.484 22.0782 14.8091Z"
      fill="white"
    />
  </svg>
)

export const CommentIcon = () => (
  <svg width="40" height="33" viewBox="0 0 40 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.5406 9C13.7192 9 9 13.7192 9 19.5406C9 25.362 13.7192 30.0811 19.5406 30.0811C21.2888 30.0811 22.9376 29.6555 24.3891 28.9023L29.0898 30.5877L27.9233 25.9316C29.2771 24.1586 30.0811 21.9435 30.0811 19.5406C30.0811 13.7192 25.362 9 19.5406 9Z"
      fill="white"
    />
  </svg>
)

export const BookmarkIcon = () => (
  <svg width="40" height="32" viewBox="0 0 40 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11 11.2613C11 10.5647 11.5647 10 12.2613 10H28.539C29.2356 10 29.8003 10.5647 29.8003 11.2613V28.2075C29.8003 29.175 28.7558 29.7822 27.915 29.3035L21.0242 25.3804C20.6373 25.1601 20.163 25.1601 19.7761 25.3804L12.8853 29.3035C12.0445 29.7822 11 29.175 11 28.2075V11.2613Z"
      fill="white"
    />
  </svg>
)

export const ShareIcon = () => (
  <svg width="40" height="34" viewBox="0 0 40 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M32.0811 18.7552L19.2813 10L19.2813 14.9565C8.08115 17.4348 8.08115 29 8.08115 29C8.08115 29 12.8811 22.3913 19.2813 23.2174L19.2813 28.3391L32.0811 18.7552Z"
      fill="white"
    />
  </svg>
)
